import {creditCard} from '../../../../core/_models'

export const buildCreditCardRequest = (data: creditCard) => {
  return {
    document: data.document,
    number: data.number,
    holder: data.holder,
    month: data.month.slice(0, 2),
    year: '20' + data.month.slice(3, 5),
    cvv: data.cvv,
    isFavorite: data.isFavorite,
  }
}
